import { createSlice } from '@reduxjs/toolkit';
import { PromotionState , Promotion } from './promotionTypes';
import { createPromotion ,fetchAllPromotion , UpdatePromotion , deletepromotion , fetchpromotionById} from './promotionAction';


const initialState : PromotionState = {
  promotion : [],
  selectedpromotion: undefined,
  loadingStates : {
    create: false,
    update: false,
    delete: false,
    fetchById: false,
    fetchAll: false,
},
errors: {
    create: undefined,
    update: undefined,
    delete: undefined,
    fetchById: undefined,
    fetchAll: undefined,
},
}


const  promotionSlice = createSlice ({
    name : 'promotion' ,
    initialState,
    reducers:{},
    extraReducers : (builder) =>{
        builder
           .addCase(createPromotion.pending, (state) => {
                                   state.loadingStates.create = true;
                                   state.errors.create = undefined;
                               })
                               .addCase(createPromotion.fulfilled, (state, action) => {
                                   state.loadingStates.create = false;
                                   state.promotion.push(action.payload);
                               })
                               .addCase(createPromotion.rejected, (state, action) => {
                                   state.loadingStates.create = false;
                                   state.errors.create = action.payload as string;
                               })
                   
                               // Update 
                               .addCase(UpdatePromotion.pending, (state) => {
                                   state.loadingStates.update = true;
                                   state.errors.update = undefined;
                               })
                               .addCase(UpdatePromotion.fulfilled, (state, action) => {
                                   state.loadingStates.update = false;
                                   const index = state.promotion.findIndex((d : any) => d.Id === action.payload.Id);
                                   if (index !== -1) {
                                       state.promotion[index] = action.payload;
                                   }
                               })
                               .addCase(UpdatePromotion.rejected, (state, action) => {
                                   state.loadingStates.update = false;
                                   state.errors.update = action.payload as string;
                               })
                   
                               // Delete 
                               .addCase(deletepromotion.pending, (state) => {
                                   state.loadingStates.delete = true;
                                   state.errors.delete = undefined;
                               })
                               .addCase(deletepromotion.fulfilled, (state, action) => {
                                   state.loadingStates.delete = false;
                                   state.promotion = state.promotion.filter((d : any) => d.Id !== action.payload);
                               })
                               .addCase(deletepromotion.rejected, (state, action) => {
                                   state.loadingStates.delete = false;
                                   state.errors.delete = action.payload as string;
                               })
                   
                               // Fetch  by ID
                               .addCase(fetchpromotionById.pending, (state) => {
                                   state.loadingStates.fetchById = true;
                                   state.errors.fetchById = undefined;
                               })
                               .addCase(fetchpromotionById.fulfilled, (state, action) => {
                                   state.loadingStates.fetchById = false;
                                   state.selectedpromotion = action.payload;
                               })
                               .addCase(fetchpromotionById.rejected, (state, action) => {
                                   state.loadingStates.fetchById = false;
                                   state.errors.fetchById = action.payload as string;
                               })
                   
                               // Fetch All 
                               .addCase(fetchAllPromotion.pending, (state) => {
                                   state.loadingStates.fetchAll = true;
                                   state.errors.fetchAll = undefined;
                               })
                               .addCase(fetchAllPromotion.fulfilled, (state, action) => {
                                   state.loadingStates.fetchAll = false;
                                   state.promotion = action.payload.data;
                               })
                               .addCase(fetchAllPromotion.rejected, (state, action) => {
                                   state.loadingStates.fetchAll = false;
                                   state.errors.fetchAll = action.payload as string;
                               }); 
    }
})

export default promotionSlice.reducer;